export function copyToClipboard(payload, onCopied) {
  return navigator.clipboard.writeText(payload).then(() => {
    if (onCopied) onCopied();
    return true;
  }).catch(err => {
    return false;
  });
}

export function copyTextOfElement(element) {
  if (!element) {
    return;
  }
  const text = element.innerText;
  return copyToClipboard(text);
}